import { gql } from '@apollo/client';

const queryDatasetDetails = (datasetUri: string) => {
    const REQUIRED_PAGE_SIZE = 100;
    const sharesFilter = {
        term: '',
        page: 1,
        pageSize: REQUIRED_PAGE_SIZE,
        roles: ['Owner'],
    };
    return {
        variables: {
            datasetUri,
            sharesFilter,
        },
        query: gql`
            query GetDataset(
                $datasetUri: String!
                $sharesFilter: ShareObjectFilter
            ) {
                getDataset(datasetUri: $datasetUri) {
                    owner
                    description
                    datasetUri
                    label
                    name
                    created
                    datasetStage
                    SamlAdminGroupName
                    originSamlAdminGroupName
                    AwsAccountId
                    region
                    enableCrawler
                    enableReadTrail
                    businessOwnerEmail
                    businessOwnerDelegationEmails
                    S3BucketName
                    targetS3BucketName
                    organization {
                        label
                        organizationUri
                    }
                    environment {
                        label
                        environmentUri
                    }
                    statistics {
                        tables
                        locations
                    }
                    userRoleForDataset
                    shares(filter: $sharesFilter) {
                        nodes {
                            status
                        }
                    }
                    stack {
                        terminationProtection
                    }
                }
            }
        `,
    };
};

export default queryDatasetDetails;
